export const Links = {
  Plan: 'plan',           // 计划
  Template: 'template',   // 模板
  Item: 'item',          // 项目
  ChildItem: 'child',    // 子项目
  Report: 'report',      // 报告
  Review: 'review',      // 审核
  Archive: 'archive'     // 归档
};
export const Status = {
  NewBuild: 1,
  InProgress: 2,
  Completed: 3,
  Audited: 4,
  ReviewFailed: 5,
};
export const ItemStatus = {
  符合: 1,
  不符合: 2,
  不适用: 3,
};
export const ItemStatusText = {
  1: "符合",
  2: "不符合",
  3: "不适用",
};
export const statusObj = {
  [Status.NewBuild]: "新建",
  [Status.InProgress]: "进行中",
  [Status.Completed]: "已完成",
  [Status.Audited]: "已审核",
  [Status.ReviewFailed]: "审核不通过",
};
export const CheckStatus = {
  PENDING: 0,     // 待检查
  PASSED: 1,      // 检查通过
  FAILED: 2,      // 检查失败
  REVIEWING: 3,   // 审核中
  APPROVED: 4,    // 已批准
  REJECTED: 5     // 已拒绝
};
export const checkStatusObj = {
  [CheckStatus.ZeroReport]: "零报告",
  [CheckStatus.RiskHazardsToBeRectified]: "风险隐患(待整改)",
  [CheckStatus.RiskHazardsAudit]: "风险隐患(已整改)",
};
export const CheckStatusLabels = {
  [CheckStatus.PENDING]: '待检查',
  [CheckStatus.PASSED]: '检查通过',
  [CheckStatus.FAILED]: '检查失败',
  [CheckStatus.REVIEWING]: '审核中',
  [CheckStatus.APPROVED]: '已批准',
  [CheckStatus.REJECTED]: '已拒绝'
};
export const links = [
  Links.Plan,
  Links.Check,
  Links.Rectification,
  Links.Examine,
  Links.End,
];

export const ImportanceLevel = {
  LOW: 'low',   // 低
  high: 'high'   // 高
};

export const InputType = {
  SELECT: 1,    // 选择
  INPUT: 2,     // 输入
  MULTIPLE: 3,  // 多选
  TEXT: 4       // 文本
};

export const DefaultTemplate = {
  template_name: "食品安全日管控默认模板",
  description: "基于食品安全法规的标准日管控检查模板，包含生产环境、进货查验、生产过程等关键控制点",
  is_default: 1,
  status: 1,

  // 主项目配置
  items: [
    {
      item_no: '1',
      item_name: '生产环境条件（厂区、车间、设施、设备等）',
      children_count: 11,
      star: 'low',
      sort_order: 1,
      status: 1,
      children: [
        {
          item_no: '1.1',
          item_name: '厂区无扬尘、无积水，厂区、车间卫生整洁',
          option_id: '1,2,3',
          star: 'low',
          input_type: 1,
          sort_order: 1,
          status: 1
        },
        {
          item_no: '1.2',
          item_name: '厂区、车间与有毒、有害场所及其他污染源保持规定的距离或具备有效防范措施',
          option_id: '1,2,3',
          star: 'high',
          input_type: 1,
          sort_order: 2,
          status: 1
        },
        {
          item_no: '1.3',
          item_name: '设备布局和工艺流程、主要生产设备设施与准予食品生产许可时保持一致',
          option_id: '1,2,3',
          star: 'low',
          input_type: 1,
          sort_order: 3,
          status: 1
        },
        {
          item_no: '1.4',
          item_name: '卫生间保持清洁，未与食品生产、包装或贮存等区域直接连通',
          option_id: '1,2,3',
          star: 'low',
          input_type: 1,
          sort_order: 4,
          status: 1
        },
        {
          item_no: '1.5',
          item_name: '有更衣、洗手、干手、消毒等卫生设备设施，满足正常使用',
          option_id: '1,2,3',
          star: 'low',
          input_type: 1,
          sort_order: 5,
          status: 1
        }
      ]
    },
    {
      item_no: '2',
      item_name: '进货查验',
      children_count: 3,
      star: 'low',
      sort_order: 2,
      status: 1,
      children: [
        {
          item_no: '2.1',
          item_name: '查验食品原料、食品添加剂、食品相关产品供货者的许可证、产品合格证明文件等',
          option_id: '1,2,3',
          star: 'high',
          input_type: 1,
          sort_order: 1,
          status: 1
        },
        {
          item_no: '2.2',
          item_name: '进货查验记录及证明材料真实、完整，记录和凭证保存期限符合要求',
          option_id: '1,2,3',
          star: 'high',
          input_type: 1,
          sort_order: 2,
          status: 1
        },
        {
          item_no: '2.3',
          item_name: '建立和保存食品原料、食品添加剂、食品相关产品的贮存、保管记录、领用出库和退库记录',
          option_id: '1,2,3',
          star: 'low',
          input_type: 1,
          sort_order: 3,
          status: 1
        }
      ]
    },
    {
      item_no: '3',
      item_name: '生产过程控制',
      children_count: 14,
      star: 'low',
      sort_order: 3,
      status: 1,
      children: [
        {
          item_no: '3.1',
          item_name: '使用的食品原料、食品添加剂、食品相关产品的品种与索证索票、进货查验记录内容一致',
          option_id: '1,2,3',
          star: 'high',
          input_type: 1,
          sort_order: 1,
          status: 1
        },
        {
          item_no: '3.2',
          item_name: '建立和保存生产投料记录，包括投料品名、生产日期或批号、使用数量等',
          option_id: '1,2,3',
          star: 'high',
          input_type: 1,
          sort_order: 2,
          status: 1
        },
        {
          item_no: '3.3',
          item_name: '未发现使用非食品原料、食品添加剂以外的化学物质、回收食品、超过保质期与不符合食品安全标准的食品原料和食品添加剂投入生产',
          option_id: '1,2,3',
          star: 'high',
          input_type: 1,
          sort_order: 3,
          status: 1
        }
      ]
    },
    {
      item_no: '4',
      item_name: '产品检验',
      children_count: 5,
      star: 'low',
      sort_order: 4,
      status: 1,
      children: [
        {
          item_no: '4.1',
          item_name: '企业自检的，具备与所检项目适应的检验室和检验能力',
          option_id: '1,2,3',
          star: 'low',
          input_type: 1,
          sort_order: 1,
          status: 1
        },
        {
          item_no: '4.2',
          item_name: '不能自检的，委托有资质的检验机构进行检验',
          option_id: '1,2,3',
          star: 'low',
          input_type: 1,
          sort_order: 2,
          status: 1
        }
      ]
    },
    {
      item_no: '5',
      item_name: '贮存及交付控制',
      children_count: 6,
      star: 'low',
      sort_order: 5,
      status: 1,
      children: [
        {
          item_no: '5.1',
          item_name: '食品原料、食品相关产品的贮存有专人管理，贮存条件符合要求',
          option_id: '1,2,3',
          star: 'low',
          input_type: 1,
          sort_order: 1,
          status: 1
        },
        {
          item_no: '5.2',
          item_name: '食品添加剂专库或专区贮存，明显标示，专人管理',
          option_id: '1,2,3',
          star: 'low',
          input_type: 1,
          sort_order: 2,
          status: 1
        }
      ]
    },
    {
      item_no: '6',
      item_name: '标签和说明书',
      children_count: 5,
      star: 'low',
      sort_order: 6,
      status: 1,
      children: [
        {
          item_no: '6.1',
          item_name: '预包装食品的包装有标签，标签标注的事项完整、真实',
          option_id: '1,2,3',
          star: 'high',
          input_type: 1,
          sort_order: 1,
          status: 1
        },
        {
          item_no: '6.2',
          item_name: '未发现标注虚假生产日期或批号的情况',
          option_id: '1,2,3',
          star: 'high',
          input_type: 1,
          sort_order: 2,
          status: 1
        }
      ]
    },
    {
      item_no: '7',
      item_name: '其他主体责任',
      children_count: 2,
      star: 'low',
      sort_order: 7,
      status: 1,
      children: [
        {
          item_no: '7.1',
          item_name: '其他不符合《食品安全法》等相关法律、法规、规章、标准和技术规范相关要求',
          option_id: '1,2,3',
          star: 'low',
          input_type: 1,
          sort_order: 1,
          status: 1
        },
        {
          item_no: '7.2',
          item_name: '对前次检查发现的问题完成整改',
          option_id: '10',
          star: 'low', // Assuming 'low' as it was cut off in the update
          input_type: 1,
          sort_order: 2,
          status: 1
        }
      ]
    }
  ]
};

export const replaceCheckList = (checklist, formData, parentName) => {
  const result = [];
  checklist.forEach((check) => {
    if (check[parentName]) {
      check[parentName] = check[parentName].map((item) => {
        if (item.itemNo === formData.itemNo) return formData;
        return item;
      });
    }
    result.push(check);
  });
  return result;
};